const AlertActionTypes = {
	SET_ALERT_MESSAGE: 'SET_ALERT_MESSAGE',
	TOGGLE_ALERT: 'TOGGLE_ALERT'
}

export default AlertActionTypes;